import React from "react";
import { Alert } from "@material-ui/lab";
import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import TelegramConnectionsItem from "./TelegramConnectionsItem";

const TelegramConnectionsList = ({ connections, onEdit, onDelete, t }) => {
  if (connections === null) return <PageSpinner position="center" pt="20" pb="20" />;
  if (connections.length === 0) return <Alert severity="warning">{t("connections.table.emptyData")}</Alert>;

  return (
    <StyledScrollTable>
      <StyledTable width="1150" size="14">
        <StyledTableHead scroll="auto" col="8">
          <div>{t("connections.table.project")}</div>
          <div>{t("connections.table.type")}</div>
          <div>{t("connections.table.connection")}</div>
          <div>{t("connections.table.service")}</div>
          <div>{t("connections.table.pairs")}</div>
          <div>{t("connections.table.status")}</div>
          <div>{t("connections.table.createdAt")}</div>
          <div>{t("connections.table.actions")}</div>
        </StyledTableHead>
        <StyledTableBody>
          {connections.map(conn => (
            <TelegramConnectionsItem key={conn.id} conn={conn} onEdit={onEdit} onDelete={onDelete} t={t} />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default TelegramConnectionsList;